// ignore-string-externalization

import React from 'react';
import { NextPage, NextPageContext } from 'next';
import { decycle, retrocycle } from 'cycle';
import {
  templateLoader,
  TemplateType,
  Template,
} from '../../features/Template';
import { NotFound } from '../../features/Layout';

export const VideoPage: NextPage<{
  template?: TemplateType | null;
  preview?: boolean;
}> = ({ template, preview }) => {
  if (!template) {
    return <NotFound />;
  }

  return (
    <Template
      {...retrocycle(template)}
      canonicalUrl={`/video/${template.urlSlug}`}
      preview={preview}
    />
  );
};

VideoPage.getInitialProps = async ({
  smartlingLanguage,
  query,
  preview,
}: NextPageContext & { preview: boolean; smartlingLanguage: string }) => {
  const urlSlug: string =
    typeof query.urlSlug === 'string'
      ? query.urlSlug
      : (query.urlSlug as string[]).join('/');

  const template = decycle(
    await templateLoader.load({
      contentType: 'videoPage',
      urlSlug,
      smartlingLanguage,
      preview,
    }),
  );

  return {
    template,
    preview,
  };
};

export default VideoPage;
